import type { OpenClawApp } from "../app.ts";
import type { SessionArtifactFileSummary } from "./chat-file-changes-summary.ts";
import { loadChatHistory } from "../controllers/chat.ts";
import {
  revertArtifactsSince,
  revertSnapshotFiles,
} from "../controllers/session-artifacts-review.ts";
import { clearChatLastRunSnapshot, resolveChatLastRunSnapshot } from "./chat-last-run-files.ts";
import { clearChatRunArtifactsBaseline, getChatRunArtifactsSinceTs } from "./chat-run-artifacts.ts";

export function collectArtifactScopeSessionKeys(
  app: OpenClawApp,
  files: SessionArtifactFileSummary[],
): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  const push = (key: string | undefined) => {
    const trimmed = key?.trim();
    if (!trimmed || seen.has(trimmed)) {
      return;
    }
    seen.add(trimmed);
    out.push(trimmed);
  };
  push(app.sessionKey);
  for (const file of files) {
    push(file.sessionKey);
  }
  for (const card of app.chatSubagents ?? []) {
    push(card.childSessionKey);
  }
  return out;
}

export function dismissComposerFileReview(app: OpenClawApp): void {
  const sessionKey = app.sessionKey.trim();
  clearChatLastRunSnapshot(app, sessionKey);
  app.chatPendingReviewChangeIds = [];
  app.chatComposerFileReviewError = null;
  if (app.chatFileDiffOpen) {
    void import("../app-file-diff.ts").then(({ closeChatFileDiff }) => closeChatFileDiff(app));
  }
}

export function advanceComposerReview(app: OpenClawApp): void {
  const sessionKey = app.sessionKey.trim();
  const snapshot = resolveChatLastRunSnapshot(app, sessionKey);
  if (!snapshot?.files.length) {
    dismissComposerFileReview(app);
    return;
  }
  const pending = new Set(app.chatPendingReviewChangeIds);
  const target =
    snapshot.files.find((f) => f.changeId && pending.has(f.changeId)) ??
    snapshot.files.find((f) => f.changeId);
  if (!target?.changeId) {
    dismissComposerFileReview(app);
    return;
  }
  void app.handleOpenChatFileDiff(target.changeId, target.path, target.sessionKey);
}
